import moment from "moment";
import {
  actives,
  originalType,
  menuType,
  roleType,
  articleTag,
  emotionalType,
  isPotoType,
  serviceType,
  buyType,
  rangeType,
  rangeNumType,
  extractType,
  rulesStatus,
  chartsType,
  dataType,
} from "../api/staticData";
import componentsJson from "../components";
// import { splitPotos } from '../utils/utils'

const PaperLookArticlePage = window.SERVERAPI.API_URL;
const VUE_APP_PRI = window.SERVERAPI.API_PRI;

// moment.locale('en', {
//   relativeTime: {
//     MM: '%d 月',
//     future: 'in %s',
//     past: '%s前',
//     s: '几秒',
//     m: '1分钟',
//     mm: '%d分钟',
//     h: '1小时',
//     hh: '%d小时',
//     d: '1天',
//     dd: '%d天'
//   }
// })

function filtersFun(arr, str = "--") {
  return function (value) {
    let o = arr.find((item) => item.value === value);
    return o ? o.label : str;
  };
}
// value 可选 new Date、时间戳、"2016-08-05 14:22:09" 时间格式
// fmt 可选 以下格式(以及位置调换)
//  yyyy-MM-dd hh:mm:ss
//  yyyy-MM-dd hh:mm:ss.S
//  yyyy/MM/dd hh:mm:ss
//  yyyy年MM月dd日 hh时mm分ss秒
//  yyyyMMddhhmmss
/* export function formatDate(value, fmt) {
  if (value === '' || value === undefined || value === null) return '--'
  let v = typeof value === 'string' ? value.replace(/-/g, '/').substring(0, 19) : value
  let date = new Date(v)
  if (date === 'Invalid Date') {
    date = new Date(parseFloat(v))
  }
  if (!fmt) {
    fmt = 'yyyy-MM-dd hh:mm:ss'
  }
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
} */
export function timeAgo(time) {
  return moment(time).fromNow();
}
export function formatSubtraction(startTime, endTime) {
  let x = moment(startTime);
  let y = moment(endTime);
  return x.from(y, true);
}

export function formatRedTitle(title, redKey = "") {
  if (redKey.substr(0, 1) === ",") {
    redKey = redKey.slice(1);
  }
  if (redKey.substr(-1) === ",") {
    redKey = redKey.substring(0, redKey.length - 1);
  }
  if (redKey) {
    return title.replace(
      new RegExp(`(${redKey.replace(",", "|")})`, "g"),
      `<span class="color-error">$1</span>`,
    );
  }
  return title || "无标题";
}
export function formatDate(time, format = "YYYY-MM-DD") {
  return moment(time).format(format);
}
export function formatNoneDate(time, format = "YYYY-MM-DD") {
  return moment(time, "YYYYMMDD").format(format);
}
export function titleFormat(title) {
  if (typeof title !== "string") return "";
  return title.replace(/头条号.*$/, "").replace(/(-|－).*$/, "");
}
export function noPFormat(title) {
  if (typeof title !== "string") return title;
  return title.replace(/<(p|\/p)[^>]*>/gi, "");
}
export function formatDay(value) {
  return `最近${value + 1}天`;
}

export function formatNull(value) {
  return value === null ? "--" : value;
}

export function isEnable(value) {
  switch (value) {
    case true:
      return "开启";
    default:
      return "禁用";
  }
}

export function shortCity(value) {
  if (!value) return "";
  return value.replace(/省|市|地区|城事/g, "");
}

export function articleType(value) {
  if (value === "" || value === "0" || value.indexOf("news") >= 0) {
    return "报纸";
  }
  if (value.indexOf("bbs") >= 0) {
    return "论坛";
  }
  if (value.indexOf("wemedia") >= 0) {
    return "宣城媒体";
  }
  if (value.indexOf("app") >= 0) {
    return "APP";
  }
  if (value.indexOf("web") >= 0 || value.indexOf("mpaccount") >= 0) {
    return "网站";
  }
  if (value.indexOf("weixin") >= 0) {
    return "微信";
  }
  if (value.indexOf("weibo") >= 0) {
    return "微博";
  }
}

export const componentsName = filtersFun(componentsJson, "组件不存在");

export function formatOriginaltype(value) {
  if (value >= 1 && value <= 9) {
    return "原创";
  } else {
    return "转载";
  }
}
export function formatTitle({ title, type, articlesequenceid }, keypar) {
  if (title === "") title = "无标题";
  else title = title.replace(/</g, "《").replace(/>/g, "》");
  var linkUrl = "";
  // alert(rowData.articlesequenceid); cycle
  if (type === "news") {
    linkUrl =
      PaperLookArticlePage +
      "/v2/page/innerview.aspx?ArticleSequenceId=" +
      articlesequenceid +
      "&keypar=" +
      encodeURIComponent(keypar);
  } else {
    linkUrl =
      (PaperLookArticlePage + "/v2/page/innerview.aspx").replace(
        "Paper/ArticlePage.aspx",
        "v2/page/innerview.aspx",
      ) +
      "?ArticleSequenceId=" +
      articlesequenceid +
      "&keypar=" +
      encodeURIComponent(keypar);
  }
  // '<a target="_blank" href="' + linkUrl + '" title="' + title + '">' + title + '</a>'
  return linkUrl;
}
export function goSource(id, text) {
  let url =
    VUE_APP_PRI +
    "/PMWeb/v2/form.html#/management/channelRuleSetting/" +
    id +
    "/" +
    encodeURIComponent(text) +
    "/0";
  window.open(url);
}

export function mainPoto(imagesource, type, paperID, paperDate, revision) {
  let imageDomain = "https://fwimage.cnfanews.com";
  if (imagesource) {
    let images = [];
    var imageOpts = [];
    images = imagesource.split("%D%W"); // 多图片分隔
    imageOpts = images[0].split(",");
    if (images[0].indexOf("http://") >= 0) {
      if (
        imageOpts[0].toLowerCase().indexOf(".jpg") > -1 ||
        imageOpts[0].toLowerCase().indexOf(".gif") > -1 ||
        imageOpts[0].toLowerCase().indexOf(".png") > -1 ||
        imageOpts[0].toLowerCase().indexOf(".jpeg") > -1 ||
        imageOpts[0].toLowerCase().indexOf(".bmp") > -1
      ) {
        return imageOpts[0].replace("#", "%23");
      } else return imageOpts[0].replace("#", "%23");
    } else {
      var firstPath = "error";
      switch (type) {
        case 1:
          firstPath = "jpg";
          break;
        case 2:
          firstPath = "pdf";
          break;
        case 3:
          firstPath = "img";
          break;
      }
      console.log(imageOpts);
      return `${imageDomain}/${firstPath}/${paperDate
        .toString()
        .substr(0, 4)}/${paperDate}/${paperID}/${revision}/${
        imageOpts[0]
      }`.toLowerCase();
    }
  }
  return "";
}

export const formatActive = filtersFun(actives);

export const formatMenu = filtersFun(menuType);

export const formatRole = filtersFun(roleType);

export const formatBuy = filtersFun(buyType);

export const formatService = filtersFun(serviceType);

export const formatarticleTag = filtersFun(articleTag);
// export const formatarticleType = filtersFun(articleType)
export const formatemotionalType = filtersFun(emotionalType);
export const formatisPotoType = filtersFun(isPotoType);
export const formatRangeType = filtersFun(rangeType);
export const formatRangeNumType = filtersFun(rangeNumType);
export const formatExtractType = filtersFun(extractType);
export const formatRulesStatus = filtersFun(rulesStatus);
export const formatChartsType = filtersFun(chartsType);
export const formatDataType = filtersFun(dataType);

export function showIssue(issue) {
  switch (issue) {
    case -1:
      return "判断异常";
    case 0:
      return "敏感预警";
    case 1:
      return "正常";
    case 2:
      return "敏感提醒";
    default:
      return "-";
  }
}

export function showUrlName(url) {
  if (url !== "") {
    var urlArr = url.split("/");
    return urlArr[urlArr.length - 1];
  }
  return "";
}

export function formatPaperName(papername) {
  if (!papername) return "";
  // 只保留第一个"-"之前的内容
  return papername.split("-")[0];
}

// 头像中的姓名只显示2个字符
export function simplify(str) {
  if (str) {
    return str.slice(-2);
  } else {
    return "--";
  }
}

// 时间过滤器
export function TimeFilter(time) {
  // 按空格分割
  var str = "";
  if (!time) return str;
  str = time.split(" ")[0];
  if (str === "1900-01-01") return "";
  return str;
}

// 时间过滤器-到分钟
export function TimeFilterMM(time) {
  if (time === "1900-01-01 00:00:00") return "";
  return moment(time).format("YYYY-MM-DD HH:mm");
}

// 金额千分号+小数点后两位
export function priceFilter(num) {
  if (!num) {
    num = 0;
  }
  num = num + "";
  if (!num.includes(".")) {
    num += ".";
  } else {
    num += "00";
    num = num.match(/^(-)?\d+(?:\.\d{0,2})?/)[0];
  }
  return num
    .replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
      return $1 + ",";
    })
    .replace(/\.$/, ""); // 暂时不要小数点后两位
  // .replace(/\.$/, ".00");
}

// 文件后缀名过滤
export function fileNameReduce(val) {
  const url = val;
  const regex = /\/(\d+\.\w+)$/;
  const match = url.match(regex);
  const filename = match[1]; // '230718042814738860.docx'
  return filename;
}

// 文件后缀名过滤2
export function fileFilter(val) {
  const url = val;
  const regex = /[^\/\\]+$/;
  const match = url.match(regex);
  const filename = match[0];
  return filename;
}

// 文件后缀名过滤2
export function checkFileType(fileUrl) {
  const fileExtension = fileUrl
      .slice(((fileUrl.lastIndexOf(".") - 1) >>> 0) + 2)
      .toLowerCase(),
    imageExtension = ["jpg", "jpeg", "png", "jpe", "gif"],
    pptExtension = ["ppt"],
    excelExtension = ["xlsx", "xls"],
    docExtension = ["doc", "docx"],
    pdfExtension = ["pdf"];
  if (imageExtension.indexOf(fileExtension) >= 0) {
    return {
      iconClass: "icon-jpg",
      // type: 0
    };
  } else if (pptExtension.indexOf(fileExtension) >= 0) {
    return { iconClass: "icon-ppt" };
  } else if (excelExtension.indexOf(fileExtension) >= 0) {
    return { iconClass: "icon-excel" };
  } else if (docExtension.indexOf(fileExtension) >= 0) {
    return { iconClass: "icon-word" };
  } else if (pdfExtension.indexOf(fileExtension) >= 0) {
    return { iconClass: "icon-pdf" };
  } else {
    return { iconClass: "icon-all-file" };
  }
  // return fileExtension; // xlsx docx等
}
export function demandStatusFilter(val) {
  let status = [
    { label: "待办", value: 0 },
    { label: "待分解", value: 1 },
    { label: "处理中", value: 2 },
    { label: "已完成", value: 3 },
    { label: "关闭", value: 4 },
  ];
  let name = "";
  status.forEach((item) => {
    if (item.value === Number(val)) {
      name = item.label;
    }
  });
  return name;
}
//排序
export function compare(p) {
  return function (m, n) {
    var a = m[p];
    var b = n[p];
    return b - a; //降序
  };
}
export function dateCompare(property, bol) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    if (bol) {
      return Date.parse(value1) - Date.parse(value2);
    } else {
      return Date.parse(value2) - Date.parse(value1);
    }
  };
}
//去重
export function objectUnique(arr, name) {
  var _hash = {};
  return arr.reduce(function (item, _next) {
    _hash[_next[name]] && _next[name]
      ? ""
      : (_hash[_next[name]] = true && item.push(_next));
    return item;
  }, []);
}
//调整分析返回数据格式
export function exec(reg, str, type) {
  str = str.replaceAll("\n", "").replaceAll("\\", "").replaceAll(" ", "");
  let result = reg[Symbol.matchAll](str);
  var arr = Array.from(result, (x) => x);
  let newarr = [];
  arr.forEach((item) => {
    if (type == "personO") {
      for (let i = 0; i < item.length; i += 3) {
        const name = item[i + 1];
        const position = item[i + 2];
        const obj = { name, position };
        newarr.push(obj);
      }
    } else if (type == "personS") {
      for (let i = 0; i < item.length; i += 2) {
        const name = item[i + 1];
        const position = "";
        const obj = { name, position };
        newarr.push(obj);
      }
    } else if (type == "event") {
      for (let i = 0; i < item.length; i += 2) {
        const event = item[i + 1];
        const obj = { event };
        newarr.push(obj);
      }
    } else if (type == "what") {
      for (let i = 0; i < item.length; i += 2) {
        const what = item[i + 1];
        const obj = { what };
        newarr.push(obj);
      }
    } else if (type == "why") {
      for (let i = 0; i < item.length; i += 2) {
        const why = item[i + 1];
        const obj = { why };
        newarr.push(obj);
      }
    } else if (type == "how") {
      for (let i = 0; i < item.length; i += 2) {
        const how = item[i + 1];
        const obj = { how };
        newarr.push(obj);
      }
    } else if (type == "location") {
      for (let i = 0; i < item.length; i += 2) {
        const location = item[i + 1];
        const obj = { location };
        newarr.push(obj);
      }
    } else if (type == "where") {
      for (let i = 0; i < item.length; i += 2) {
        const where = item[i + 1];
        const obj = { where };
        newarr.push(obj);
      }
    }
  });
  return newarr;
}
// 删除时间后面3位
export function handleTime(val) {
  let reg = val.match(/\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}/);
  let time = reg;
  return time[0];

  // var pattern = /\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}/;
  // return text.replace(pattern, function (match) {
  //   return match.substr(0, 19);
  // });
}
// 根据字段去重
export function removeRepeat(data, key = "same_id") {
  let dataKeys = {};
  return data.filter((a) => {
    if (!a[key]) {
      return true;
    } else if (dataKeys[a[key]]) {
      return false;
    } else {
      dataKeys[a[key]] = true;
      return true;
    }
  });
}
